import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { App as CapApp } from "@capacitor/app";
import { api } from "@/lib/api";

// Native Google login: open Emergent auth in the SYSTEM browser and return via a
// deep link (app.jeeo.mobile://auth#session_id=...). Web login is handled separately.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const isNative = () => Capacitor.isNativePlatform();

const DEEP_LINK = "app.jeeo.mobile://auth";

export async function nativeLogin() {
  await Browser.open({
    url: `https://auth.emergentagent.com/?redirect=${encodeURIComponent(DEEP_LINK)}`,
  });
}

// Exchange a session_id (from the deep link) for a stored Bearer token.
export async function exchangeSession(sessionId) {
  const r = await api.post("/auth/session", { session_id: sessionId });
  if (r.data?.session_token) {
    localStorage.setItem("jeeo_session_token", r.data.session_token);
  }
  return r.data;
}

// Register once at app start: capture the deep-link redirect and finish login.
export function initNativeAuthListener(onLoggedIn) {
  if (!isNative()) return;
  CapApp.addListener("appUrlOpen", async ({ url }) => {
    if (!url || !url.includes("session_id=")) return;
    try {
      const sid = url.split("session_id=")[1].split(/[&#]/)[0];
      const user = await exchangeSession(decodeURIComponent(sid));
      await Browser.close().catch(() => {});
      onLoggedIn && onLoggedIn(user);
    } catch (e) {
      console.error("native auth exchange failed", e);
    }
  });
}

export function nativeLogout() {
  localStorage.removeItem("jeeo_session_token");
}
